/* global gdAlertify */
import { useState, useEffect } from "react";
import { formatDate } from "../utils/utils";
import axiosInstance from "../config/axiosConfig";
import MonthInput from "./components/MonthInput";

const SeguimientoPagos = () => {
    const [periodo, setPeriodo] = useState("");
    const [pagos, setPagos] = useState([]);
    const [showDetalleModal, setShowDetalleModal] = useState(false);
    const [pacienteSeleccionado, setPacienteSeleccionado] = useState(null);

    useEffect(() => {
        if (!periodo) {
            setPagos([]); // No cargar datos si no hay período seleccionado
            return;
        }

        async function buscarPaciente() {
            try {
                const response = await axiosInstance.get("/paciente/busqueda");
                const pacientes = response.data.data.map((paciente) => ({
                    id: paciente.id,
                    paciente: `${paciente.nombres} ${paciente.apellidoPaterno}`,
                    turnos: "-",
                    total: "-",
                    periodo: periodo,
                    fecha_ultimo: `${periodo}-01`, // Primer día del mes seleccionado
                    estadoPago: "Pendiente",
                }));
                setPagos(pacientes);
            } catch (error) {
                console.error("Error al buscar Paciente: ", error);
            }
        }

        buscarPaciente();
    }, [periodo]);

    const notificarPago = (id) => {
        gdAlertify.confirm({
            title: "Notificar",
            message: "¿Está seguro de notificar al paciente?",
            onConfirm: () => {
                gdAlertify.notify("Envío con éxito", "success");
            },
            onCancel: () => {
                gdAlertify.notify("Envío cancelado", "error");
            },
        });
    };

    const verDetalle = (id) => {
        setPacienteSeleccionado(id);
        setShowDetalleModal(true);
    };

    return (
        <div className="container mt-4">
            <div className="card p-3">
                <h4>Seguimiento de Pagos</h4>
                <div className="mb-3">
                    <label className="form-label">Periodo:</label>
                    <MonthInput
                        className="form-control"
                        value={periodo}
                        onChange={(e) => setPeriodo(e.target.value)}
                    />
                </div>
            </div>
            {pagos.length > 0 && (
                <div className="card mt-3 p-3">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Paciente</th>
                                <th>Cantidad de Turnos</th>
                                <th>Valor Total</th>
                                <th>Periodo</th>
                                <th>Fecha Última Notificación</th>
                                <th>Estado del Pago</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pagos.map((pago) => (
                                <tr key={pago.id}>
                                    <td>{pago.paciente}</td>
                                    <td>{pago.turnos}</td>
                                    <td>{pago.total}</td>
                                    <td>{pago.periodo}</td>
                                    <td>{pago.fecha_ultimo}</td>
                                    <td>{pago.estadoPago}</td>
                                    <td>
                                        <button className="btn btn-warning me-2" onClick={() => notificarPago(pago.id)}>
                                            Notificar Pago
                                        </button>
                                        <button className="btn btn-info" onClick={() => verDetalle(pago.id)}>
                                            Ver Detalle
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showDetalleModal && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Detalle del Paciente</h5>
                                <button type="button" className="btn-close" onClick={() => setShowDetalleModal(false)}></button>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowDetalleModal(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SeguimientoPagos;